import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import cn from 'classnames'

export default class InternalPage extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    header: PropTypes.node,
    children: PropTypes.node
  }

  componentDidMount() {
    document.title = this.props.title || ''
  }

  render() {
    const {header, children, onlyContent} = this.props

    return (
      <div className={cn(styles.root, onlyContent && styles.noPadding)}>
        <div className={styles.content}>
          {header}
          <div className={styles.main}>{children}</div>
        </div>
      </div>
    )
  }
}
